export const pago_subcategoria = [
  {
    label: "Id",
    name: "idpago_subcategoria",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Categoría",
    name: "idpago_categoria",
    type: "pago_categoria",
    showOnList: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Tipo",
    name: "tipo",
    type: "STRINGINLIST",
    allowNull: true,
    options: ["Directo", "Indirecto", "Ninguno"],
  },
];
